module.exports = __webpack_public_path__ + "img/h&s3.4f3a92ca.jpeg";